var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"newDom"}},[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-big-play-centered",attrs:{"id":"videoPlayer","width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }